{
 "title": {
  "x": 333,
  "y": 341,
  "w": 274,
  "h": 45,
  "lane": {
   "x": 250,
   "y": 330,
   "w": 440,
   "h": 70
  }
 },
 "balance": {
  "x": 469,
  "y": 476,
  "w": 102,
  "h": 61,
  "lane": {
   "x": 430,
   "y": 470,
   "w": 180,
   "h": 90
  }
 },
 "r1.name": {
  "x": 247,
  "y": 669,
  "w": 221,
  "h": 32,
  "lane": {
   "x": 240,
   "y": 660,
   "w": 360,
   "h": 52
  }
 },
 "r1.sub": {
  "x": 247,
  "y": 721,
  "w": 174,
  "h": 24,
  "lane": {
   "x": 240,
   "y": 712,
   "w": 360,
   "h": 44
  }
 },
 "r1.price": {
  "x": 674,
  "y": 682,
  "w": 117,
  "h": 29,
  "lane": {
   "x": 630,
   "y": 668,
   "w": 206,
   "h": 70
  }
 },
 "r2.name": {
  "x": 247,
  "y": 842,
  "w": 223,
  "h": 32,
  "lane": {
   "x": 240,
   "y": 834,
   "w": 360,
   "h": 52
  }
 },
 "r2.sub": {
  "x": 247,
  "y": 894,
  "w": 176,
  "h": 31,
  "lane": {
   "x": 240,
   "y": 886,
   "w": 360,
   "h": 44
  }
 },
 "r2.price": {
  "x": 674,
  "y": 855,
  "w": 117,
  "h": 29,
  "lane": {
   "x": 630,
   "y": 842,
   "w": 206,
   "h": 70
  }
 },
 "tag": {
  "x": 268,
  "y": 992,
  "w": 173,
  "h": 20,
  "lane": {
   "x": 246,
   "y": 982,
   "w": 216,
   "h": 44
  }
 },
 "r3.name": {
  "x": 247,
  "y": 1035,
  "w": 249,
  "h": 32,
  "lane": {
   "x": 240,
   "y": 1026,
   "w": 360,
   "h": 52
  }
 },
 "r3.sub": {
  "x": 248,
  "y": 1089,
  "w": 250,
  "h": 24,
  "lane": {
   "x": 240,
   "y": 1078,
   "w": 360,
   "h": 44
  }
 },
 "r3.price": {
  "x": 674,
  "y": 1028,
  "w": 117,
  "h": 29,
  "lane": {
   "x": 630,
   "y": 1014,
   "w": 206,
   "h": 70
  }
 },
 "r4.name": {
  "x": 247,
  "y": 1193,
  "w": 250,
  "h": 32,
  "lane": {
   "x": 240,
   "y": 1184,
   "w": 360,
   "h": 52
  }
 },
 "r4.sub": {
  "x": 247,
  "y": 1245,
  "w": 165,
  "h": 24,
  "lane": {
   "x": 240,
   "y": 1236,
   "w": 360,
   "h": 44
  }
 },
 "r4.price": {
  "x": 661,
  "y": 1203,
  "w": 143,
  "h": 29,
  "lane": {
   "x": 630,
   "y": 1190,
   "w": 206,
   "h": 70
  }
 },
 "note": {
  "x": 148,
  "y": 1342,
  "w": 645,
  "h": 31,
  "lane": {
   "x": 120,
   "y": 1336,
   "w": 700,
   "h": 46
  }
 }
}